import { Component, OnInit } from '@angular/core';
import { TableService } from './table.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  data: any[] = [];
  currentPage: number = 1;
  totalPages: number = 0;

  constructor(private tableService: TableService) { }

  ngOnInit() {
    const fetchedData = [
      { id: 1, name: 'John Doe' },
      { id: 2, name: 'Jane Smith' },
    ];
    this.tableService.setData(fetchedData);

    this.tableService.getData().subscribe(data => {
      this.data = data;
    });

    this.tableService.currentPage$.subscribe(page => {
      this.currentPage = page;
    });

    this.tableService.totalPages$.subscribe(totalPages => {
      this.totalPages = totalPages;
    });
  }

  searchData(searchTerm: string) {
    this.tableService.searchData(searchTerm);
  }

  sortData(column: string) {
    const direction = column === 'asc' ? 'desc' : 'asc';
    this.tableService.sortData(column, direction);
  }

  goToPage(page: number) {
    this.tableService.goToPage(page);
  }

  goToFirstPage() {
    this.tableService.goToFirstPage();
  }

  goToLastPage() {
    this.tableService.goToLastPage();
  }

  goToPreviousPage() {
    this.tableService.goToPreviousPage();
  }

  goToNextPage() {
    this.tableService.goToNextPage();
  }

  loadMore() {
    this.tableService.loadMore();
  }
}
